<template>
  <div>
    <v-card class="mr-4">
      <v-card-title class="bg-light border-bottom">
        <h5>Berechnung</h5>
      </v-card-title>
      <v-card-text class="mt-2">
        <u-loader v-if="remainingValidations > 0" />

        <div v-show="remainingValidations <= 0">
          <div v-if="structure.length <= 0">
            Struktur wurde noch nicht geladen oder wurde noch nicht definiert.
          </div>
          <div v-else>
            <div class="">
              <div
                v-for="validation in allValidations"
                :key="'validation_' + validation.id"
              >
                <Validation
                  :contract-id="contractId"
                  :configuration-id="editionId"
                  :structure="structure"
                  :validation-object="validation"
                  :version-number="versionId"
                  class="w-100"
                  @validationUpdated="getValidations()"
                />
                <hr>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn btn-success float-right smallActionButton"
                  placement="bottom"
                  title="Validierung hinzufügen"
                  type="button"
                  @click="showModal('createNewValidation')"
                >
                  <i class="fas fa-plus" />
                </button>
              </div>
            </div>
            <u-error-handling
              v-if="validateAllErrorObject"
              :error-object="validateAllErrorObject"
            />
          </div>
        </div>
      </v-card-text>
      <v-card-actions v-if="canUserEdit">
        <button
          v-b-tooltip.hover
          class="btn btn-success ml-0 mt-4"
          placement="bottom"
          title="Alle Validierungen prüfen"
          type="button"
          @click="checkAllValidations"
        >
          Alle überprüfen
        </button>
      </v-card-actions>
    </v-card>

    <b-modal
      id="createNewValidation"
      ref="createNewValidation"
      class="w-100"
      hide-footer
      no-fade
      scrollable
      title="Validierung erstellen"
    >
      <u-error-handling
        v-if="newErrorObject"
        :error-object="newErrorObject"
      />
      <div class="d-block mb-4">
        Sind Sie sicher, dass Sie eine neue Validierung erstellen möchten?
      </div>
      <b-button
        variant="success"
        @click="createNewValidation()"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal('createNewValidation')"
      >
        Abbrechen
      </b-button>
    </b-modal>

    <MinimumWageValidation :config-id="editionId" />
  </div>
</template>

<script>
import {
  GetValidations,
  RunValidation,
  AddValidation,
} from "@/services/minimum.wage.services/validation.minimum.wages.js";
import MinimumWageValidation from "@/components/minimum.wage/pages/Validation/LegalMinimumWageValidation.vue";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

import Validation from "@/components/minimum.wage/pages/Validation/Validation.vue";

export default {
  components: {
    Validation,
    MinimumWageValidation,
  },
  mixins: [MinimumWageMixin],
  data() {
    return {
      allValidations: [],
      errorObject: null,
      newErrorObject: null,
      structureWidth: 60,
      validateAllErrorObject: null,
      remainingValidations: 0,
    };
  },
  computed: {
    structure() {
      return this.$store.state.mindestLohnKonfiguration.StructureFlat;
    },
  },
  created() {
    this.getValidations();
  },
  methods: {
    hideModal(modalId) {
      this.$refs[modalId].hide();
    },
    getValidations() {
      this.errorObject = null;

      GetValidations(
        this.contractId,
        this.versionId,
        this.editionId,
        (response) => {
          this.allValidations = JSON.parse(JSON.stringify(response));
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    createNewValidation() {
      this.newErrorObject = null;
      this.isLoading = true;

      var newValidation = {
        id: 0,
        configurationId: 0,
        order: 0,
        validationEntries: [],
      };

      this.structure.map((structure) => {
        newValidation.validationEntries.push({
          id: 0,
          criteriaStructureId: structure.id,
          value: "",
          criteriaListEntryId: null,
        });
      });

      AddValidation(
        this.contractId,
        this.versionId,
        this.editionId,
        newValidation,
        () => {
          this.hideModal("createNewValidation");
          this.getValidations();
        },
        (error) => {
          this.isLoading = false;
          this.newErrorObject = error;
        },
      );
    },
    checkAllValidations() {
      this.validateAllErrorObject = null;

      this.remainingValidations = this.allValidations.length;

      this.allValidations.map((validation) => {
        RunValidation(
          this.contractId,
          this.versionId,
          this.editionId,
          validation.id,
          () => {
            this.remainingValidations--;
            if (this.remainingValidations <= 0) {
              this.getValidations();
            }
          },
          () => {
            this.remainingValidations--;
            if (this.remainingValidations <= 0) {
              this.getValidations();
            }
          },
        );
      });
    },
  },
};
</script>

<style scoped>
.min-height-50 {
  min-height: 50px;
}

.smallActionButton {
  width: 35px;
  height: 35px;
  font-size: 20px;
  padding: 0px;
}
</style>
